import { render, staticRenderFns } from "./RowElementText.vue?vue&type=template&id=6633cdc2&scoped=true&"
import script from "./RowElementText.vue?vue&type=script&lang=js&"
export * from "./RowElementText.vue?vue&type=script&lang=js&"
import style0 from "./RowElementText.vue?vue&type=style&index=0&id=6633cdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633cdc2",
  null
  
)

export default component.exports